// Typed accessor over the generated manifest (scripts/build-blog-manifest.mjs,
// run by predev/prebuild/pretest). If this import is red in your editor, run
// `node scripts/build-blog-manifest.mjs` once.
import manifest from '../generated/blog-manifest.json'

export interface BlogPostMeta {
  slug: string
  title: string
  description: string
  date: string
  hero: string | null
  heroAlt: string | null
}

/** Sorted newest first by the generator. Do not re-sort. */
export const BLOG_POSTS: BlogPostMeta[] = manifest

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

/** '2026-08-14' -> 'August 14, 2026'. Mirrors scripts/blog-lib.mjs formatDate. */
export function formatBlogDate(iso: string): string {
  const [y, m, d] = iso.split('-').map(Number)
  return `${MONTHS[m - 1]} ${d}, ${y}`
}
